import { render, staticRenderFns } from "./ToPayTab.vue?vue&type=template&id=027adf04&scoped=true&"
import script from "./ToPayTab.vue?vue&type=script&lang=js&"
export * from "./ToPayTab.vue?vue&type=script&lang=js&"
import style0 from "./ToPayTab.vue?vue&type=style&index=0&id=027adf04&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027adf04",
  null
  
)

export default component.exports